import { LuClock, LuX } from "react-icons/lu";
import { motion } from "motion/react";
import FormInput from "../../../../../../../../../../components/FormInput";
import { UseFormRegister, FieldErrors } from "react-hook-form";
import { ActivityFormValues } from "../../zod/activitySchema";

interface TimeSectionProps {
  register: UseFormRegister<ActivityFormValues>;
  errors: FieldErrors<ActivityFormValues>;
  displayEndTime: boolean;
  setDisplayEndTime: (display: boolean) => void;
}

export default function TimeSection({
  register,
  errors,
  displayEndTime,
  setDisplayEndTime,
}: TimeSectionProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-4">
        <FormInput
          className="w-full"
          id="startDay"
          label="Date *"
          type="date"
          register={register}
          error={errors.startDay}
        />
        <FormInput
          className="w-full"
          id="startTime"
          label="Heure *"
          type="time"
          register={register}
          error={errors.startTime}
        />
      </div>
      {displayEndTime ? (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 10 }}
          transition={{ duration: 0.3 }}
          className="flex flex-col border border-border rounded-md p-2 relative"
        >
          <div className="flex-1 flex items-center gap-2 absolute right-2 top-2">
            <div
              onClick={() => setDisplayEndTime(false)}
              className="text-tertiary hover:text-primary transition-colors cursor-pointer"
            >
              <LuX className="w-4 h-4" />
            </div>
          </div>
          <div className="flex gap-4">
            <FormInput
              className="w-full"
              id="endDay"
              label="Date de fin *"
              type="date"
              register={register}
              error={errors.endDay}
            />
            <FormInput
              className="w-full"
              id="endTime"
              label="Heure de fin *"
              type="time"
              register={register}
              error={errors.endTime}
            />
          </div>
        </motion.div>
      ) : (
        <div
          className="flex items-center gap-2 cursor-pointer text-secondary hover:text-primary/80 transition-all duration-300"
          onClick={() => setDisplayEndTime(true)}
        >
          <LuClock className="w-4 h-4" />
          Renseigner une <span className="underline">une heure de fin</span>
        </div>
      )}
    </div>
  );
}
